import {IOverride} from "../../index";
import {IParams, IStatus, IMoreStatus, IWhomWhen} from "./index";
import {_} from 'lodash';
import AbstractHtml from './Abstract.html?raw';
import tooltipHtml from './tooltip.html?raw';

export const template = AbstractHtml;
export const templateTooltip = tooltipHtml;
export const TemplatePlaceholder = '{{ TEMPLATE }}';

export abstract class OverrideAbstractViewModel {
    protected override: IOverride;
    protected status: IStatus;

    constructor(params: IParams) {
        this.override = params.override;
        this.status = this.getStatus();
    }

    protected getStatus(obj: Partial<IStatus> = {}): IStatus {
        return _.extend(
            {
                icon: this.getIcon(),
                value: null,
            },
            obj,
            this.getWhomAndWhen(),
            this.getMoreStatus()
        );
    }


    protected getIcon(): string {
        const {isSynced, isDeleted} = this._getStatus();
        return isSynced && !isDeleted ? 'fa-check fa-rw' : 'fa-hourglass fa-rw';
    }

    protected _getStatus(): { isDeleted: boolean, isSynced: boolean } {
        const o = this.override;
        const isDeleted = !!o.deletedbyid;
        const isSynced = !!o.syncronizedimportfileid;
        return {isDeleted, isSynced};
    }

    protected getWhomAndWhen(): IWhomWhen {
        const o = this.override;
        const {isDeleted} = this._getStatus();
        return {
            by: isDeleted ? o.deletedby : o.overriddenby,
            id: isDeleted ? o.deletedbyid : o.overriddenbyid,
            when: isDeleted ? o.deletedwhen : o.overriddenwhen,
        }
    }

    protected abstract getMoreStatus(): IMoreStatus;

}

